// extracted by mini-css-extract-plugin
export var filterIncDec = "_ak-0";
export var leftBorder = "_ak-1";
export var rightBorder = "_ak-2";
export var stringInput = "_ak-3";